const WORDED_FAILURES: readonly {
  matches: RegExp;
  words: string | ((match: RegExpExecArray) => string);
}[] = [
  {
    matches: /^Sandbox tail became stale/,
    words:
      'cubic lost contact with the workspace while the agent was working. Nothing in the workspace was removed; send the message again to reconnect.',
  },
  {
    matches: /^Code session is busy\./,
    words:
      'Another action in this session was still running, so this one did not start. Send the message again.',
  },
  {
    matches: /^Front door unavailable/,
    words: 'cubic could not reach the workspace in time. Send the message again.',
  },
  {
    matches: /^The operation was aborted due to timeout/,
    words: 'A step of this turn took too long, so cubic stopped it. Send the message again.',
  },
  {
    matches: /^Status code 429 /,
    words:
      'The workspace provider is limiting how often cubic can start workspaces. Wait a minute, then send the message again.',
  },
  {
    matches:
      /^(cannot execute \w+ in a read-only transaction|canceling statement due to statement timeout|Could not coordinate this code session)/,
    words: 'cubic hit an internal error while handling this turn. Send the message again.',
  },
  {
    matches: /^Provider request failed with HTTP (5\d\d)/,
    words: ([, status]) =>
      `The model provider did not answer (HTTP ${status}). Send the message again.`,
  },
];

/**
 * The words a person reads for a failed turn's saved message, or null for a turn that saved no
 * reason, so each place says that in its own words.
 */
export function turnFailureWords(errorMessage: string | null | undefined): string | null {
  const message = errorMessage?.trim() ?? '';
  if (message.length === 0) {
    return null;
  }
  for (const { matches, words } of WORDED_FAILURES) {
    const match = matches.exec(message);
    if (match !== null) {
      return typeof words === 'string' ? words : words(match);
    }
  }
  return message;
}
